import { Services } from '@prz-dp/services';
import Vue from 'vue';

// import KitWorker from 'worker-loader!@prz-dp/worker/dist/index.js';
import APP from '@/constants/application.constant';
import router from '@/plugins/router.plugin';
import store from '@/store';

Vue.use(Services, {
  options: {
    auth: APP.auth,
    clientLogUri: APP.clientLogUri,
    domain: APP.domain,
    refreshDirectlyWithKeycloak: APP.refreshDirectlyWithKeycloak,
    refreshUri: APP.refreshUri
  },
  router,
  store
  // worker: KitWorker
});
